// Emails.jsx
import { useMemo, useState } from "react";
import { Badge } from "flowbite-react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

function uniqueDomains(emails = []) {
  const set = new Set();
  emails.forEach((e) => {
    const val = (e?.email || "").toString().trim();
    const at = val.indexOf("@");
    if (at > 0) set.add(val.slice(at + 1).toLowerCase());
  });
  return Array.from(set);
}

const Emails = ({ emails = [] }) => {
  const [expandido, setExpandido] = useState(false);

  const LIMITE = 5;
  const total = emails.length;
  const restantes = Math.max(total - LIMITE, 0);
  const dominios = uniqueDomains(emails);

  const listaExibida = useMemo(
    () => (expandido ? emails : emails.slice(0, LIMITE)),
    [expandido, emails]
  );

  return (
    <>
      {/* Resumo */}
      <div className="flex flex-wrap gap-3 mb-5 mt-3">
        {total > 0 && (
          <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 px-3 py-1.5 rounded-full text-sm font-medium">
            <span>Quantidade Total:</span>
            <span>{total}</span>
          </div>
        )}

        {dominios.length > 0 && (
          <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 text-gray-700 px-3 py-1.5 rounded-full text-sm font-medium">
            <span>Domínios únicos:</span>
            <span>{dominios.length}</span>
          </div>
        )}
      </div>

      {/* Lista */}
      <div className="relative rounded-2xl border border-gray-200 overflow-hidden">
        <div className="bg-blue-50 px-4 py-3 border-b border-gray-200">
          <div className="grid gap-2 text-xs font-semibold text-gray-600 uppercase tracking-wider grid-cols-2">
            <div>E-mail</div>
            <div>Domínio</div>
          </div>
        </div>

        <div
          className={`transition-all duration-300 ease-out ${
            expandido ? "max-h-[9999px]" : "max-h-auto"
          } overflow-hidden`}
        >
          {listaExibida.map((item, index) => {
            const val = (item?.email || "-").toString().trim();
            const dom = val.includes("@")
              ? val.split("@")[1].toLowerCase()
              : "-";
            return (
              <div
                key={index}
                className={`grid gap-2 px-4 py-3 text-sm items-center grid-cols-2 ${
                  index % 2 === 0 ? "bg-white" : "bg-gray-50"
                }`}
              >
                <div className="font-medium text-gray-900 break-words">
                  {val || "-"}
                </div>
                <div className="text-gray-700 break-words">{dom}</div>
              </div>
            );
          })}
        </div>

        {!expandido && total > LIMITE && (
          <div className="pointer-events-none absolute inset-x-0 bottom-[52px] h-16 bg-gradient-to-t from-white to-white/0" />
        )}

        {total > LIMITE && (
          <div className="flex items-center justify-between gap-3 px-4 py-3 bg-white border-t border-gray-200">
            <button
              type="button"
              onClick={() => setExpandido((v) => !v)}
              aria-expanded={expandido}
              className="inline-flex items-center gap-2 rounded-xl border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {expandido ? (
                <>
                  <HiChevronUp className="text-lg" />
                  Ver menos
                </>
              ) : (
                <>
                  <HiChevronDown className="text-lg" />
                  Ver mais
                </>
              )}
            </button>
            <div className="flex items-center gap-2 text-xs text-gray-600">
              <Badge color="gray">
                Exibindo {Math.min(LIMITE, total)} de {total}
              </Badge>
              {!expandido && restantes > 0 && (
                <span className="text-gray-500">(+{restantes} restantes)</span>
              )}
            </div>
          </div>
        )}
      </div>

      {!expandido && total > LIMITE && (
        <div className="text-sm mt-3 text-gray-500 text-center">
          Exibindo as últimas {LIMITE} ocorrências.
        </div>
      )}
    </>
  );
};

export default Emails;
